import React, { useCallback, useState } from 'react';
import { Button, View } from "./Themed"
import { FlatList } from 'react-native';
import { useColors } from '../constants/useColors';

type PaginationProps = {
    offset:number
    style?:any,
    pages?:number,
    next_title?:string,
    previous_title?:string,
    onPrevious?: () => void,
    onNext?: () => void,
    onSelectPage?:(page:number) => void
}

const Pagination = ({ offset, pages, onPrevious, onNext, next_title, previous_title, style, onSelectPage }:PaginationProps) => {
    const Colors = useColors();
    const [ width, setWidth ] = useState(0);
    let pagination_dots = useCallback(() => {
        if(!pages){ return [] }
        const arr = Array.from({ length: pages }, (_, i) => i);
        return arr
    },[pages]);
    const page_dots = pagination_dots();
    const renderDots = (data:{ item:number, index:number }) => {
        const active = offset == data.item ? true : false
        return (
            <Button transparent disabled={!onSelectPage} 
            style={{ padding:10, width: width / page_dots.length, justifyContent:'center', alignItems:'center' }}
            onPress={() => onSelectPage ? onSelectPage(data.item): console.log('')}>
                <View style={{ height:active ? 10 : 8, width:active ? 10 : 8, borderRadius:100, backgroundColor:active ? Colors.text.action :Colors.text.h1, opacity: active? 1 : 0.8 }} />
            </Button>
        )
    }

    return (
        <View transparent style={{ flexDirection: 'row', alignItems:'center', ...style }}>
            {onPrevious ?
            <Button
                disabled={offset == 0}
                style={{ opacity: offset == 0 ? 0.4: 1 }}
                title={previous_title ?? 'PREV'}
                type='text'
                onPress={() => onPrevious()}
            />
            :<></>}
            <View transparent style={{ flex:1 }} onLayout={(ev) => {
                const { width } = ev.nativeEvent.layout;
                setWidth(width);
            }}>
                <FlatList
                    data={page_dots}
                    keyExtractor={(item) => item.toString()}
                    key={'pagination_dots'}
                    showsHorizontalScrollIndicator={false}
                    renderItem={renderDots}
                    horizontal

                />
            </View>
            {onNext ?
            <Button
                title={next_title ?? 'NEXT'}
                style={{ opacity: pages && pages == offset + 1  ? 0.4 : 1 }}
                disabled={pages && pages == offset + 1  ? true : false}
                type='text'
                onPress={() => onNext()}
            />
            :<></>}
        </View>
    )
}

export default Pagination